import Vue from 'vue'
import Vuex from 'vuex'
import {
  login as loginApi,
  fetchAuthToken as fetchAuthTokenApi,
  listB2C as listB2CApi,
  listInvoicers as listInvoicersApi,
  getInvoicee as getInvoiceeApi,
  deleteInvoices as deleteInvoicesApi,
  listContract as listContractApi,
  updateInvoicee as updateInvoiceeApi,
  getSession, deleteSession as deleteSessionApi
} from '../client'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    user: {
      userData: null,
      userAddresses: [],
      authToken: null,
      userContracts: []
    },
  },
  mutations: {
    SET_USER_DATA(state, data) {
      state.user.userData = data
      localStorage.setItem("user", JSON.stringify({ TransferID: data.TransferID, TransferKey: data.TransferKey }))
    },
    SET_USER_ADDRESSES(state, data) {
      state.user.userAddresses = data
    },
    SET_USER_CONTRACTS(state, data) {
      state.user.userContracts = data
    },
    SET_AUTH_TOKEN(state, data) {
      state.user.authToken = data
    },
    DELETE_SESSION(state, data) {
      state.user.authToken = null
      state.user.userAddresses = []
      state.user.userData = null
      localStorage.removeItem("user")
      sessionStorage.removeItem("user")
    },
    SET_SUPPLIERS(state, data) {
      state.suppliers = data
    },
    ADD_SUPPLIER(state, data) {
      state.suppliers.push(data)
    },
    SET_LOCALE(state, data) {
      state.i18n.locale = data
      localStorage.setItem("locale", data)
    }
  },
  actions: {
    login({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          let response = await loginApi(params)
          let userData = {}
          if (Array.isArray(response)) {
            let user = response.shift()
            userData = user.Value.reduce((acc, curr) => {
              acc[curr["@type"]] = curr["$"] || ""
              return acc
            }, {})

            commit('SET_USER_DATA', userData)
            const { TransferID, TransferKey } = userData
            let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
            resolve(tokenRes)
          } else {

            let user = response
            userData = user.Value.reduce((acc, curr) => {
              acc[curr["@type"]] = curr["$"] || ""
              return acc
            }, {})

            commit('SET_USER_DATA', userData)
            const { TransferID, TransferKey } = userData
            let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
            resolve(tokenRes)
          }
        } catch (error) {
          reject(error)
        }
      })

    },
    async listContract({ commit }, { TransferID, TransferKey, UniqueCompanyID }) {
      try {
        let arr = await listContractApi({ TraID: TransferID, tkey: TransferKey, cid: UniqueCompanyID })
        let contracts = arr.map(c => {
          return c.Value.reduce((acc, curr) => {
            acc[curr.type] = curr["_@ttribute"] || ""
            return acc
          }, {})
        })
        commit('SET_USER_CONTRACTS', contracts)
      } catch (error) {
        console.log(error)
      }
    },
    listB2C({ commit }, req) {
      return listB2CApi(req)
    },
    listInvoicers() {
      return listInvoicersApi()
    },
    getInvoicee({ commit }, req) {
      return getInvoiceeApi(req)
    },
    updateInvoicee({ commit }, req) {
      return updateInvoiceeApi(req)
    },
    deleteInvoices({ commit }, req) {
      return deleteInvoicesApi(req)
    },
    setLocale({ commit }, data) {
      commit('SET_LOCALE', data)
      localStorage.setItem("locale", data)
    },
    async fetchAuthToken({ commit }, { TransferID, TransferKey }) {
      try {
        let token = await fetchAuthTokenApi(TransferID, TransferKey)
        commit('SET_AUTH_TOKEN', token.token)
        return true
      } catch (error) {
        console.log(error)
        throw error
      }

    },
    loadSession({ commit },) {
      return new Promise(async (resolve, reject) => {
        let user = localStorage.getItem("user")
        if (user) {
          try {
            user = JSON.parse(user)
            let response = await getSession({ TraID: user.TransferID, tkey: user.TransferKey })
            let userData = {}
            if (Array.isArray(response)) {
              let user = response.shift()
              userData = user.Value.reduce((acc, curr) => {
                acc[curr["@type"]] = curr["$"] || ""
                return acc
              }, {})

              commit('SET_USER_DATA', userData)
              const { TransferID, TransferKey } = userData
              let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
              resolve(tokenRes)
            } else {

              let user = response
              userData = user.Value.reduce((acc, curr) => {
                acc[curr["@type"]] = curr["$"] || ""
                return acc
              }, {})

              commit('SET_USER_DATA', userData)
              const { TransferID, TransferKey } = userData
              let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
              resolve(tokenRes)
            }
          } catch (error) {
            reject(error)
          }
        } else {
          reject(false)
        }

      })

    },

    deleteSession({ commit, getters }) {
      const { TransferID, TransferKey } = getters.userData
      deleteSessionApi({ TraID: TransferID, tkey: TransferKey })
      commit('DELETE_SESSION')
    },

  },
  modules: {
  },
  getters: {
    authToken: state => {
      return state.user.authToken
    },
    userData: state => {
      return state.user.userData
    },

    isLoggedIn: state => {
      return state.user.userData !== null && state.user.authToken !== null
    },

    userContracts: state => {
      return state.user.userContracts
    }
  }
})
